import React, { useContext, useRef } from 'react'
import { navigate } from 'gatsby'

import Button from '../../atoms/button/button'

import { Context } from '../../../context/app-context'
import { siteUrl } from '../../../shared/utils/siteUrl'

import laptop from '../../../assets/images/laptop.png'
import paquete from '../../../assets/images/paquete.png'
import puntos20 from '../../../assets/images/puntos20.png'
import puntos5 from '../../../assets/images/puntos5.png'
import jackPotParticipar from '../../../assets/images/jackPotParticipar.png'
import premiosParticipa_DO from '../../../assets/images/premiosParticipa_DO.png'

import './participaSection.scss'

const ParticipaSection = props => {
  const { mobile } = props

  const { dispatch } = useContext(Context)

  const modalLogin = () => {
    dispatch({
      type: 'set',
      payload: {
        modalActive: {
          type: 'login',
          handleClose: () => {
            navigate('/')
          },
          props: {
            colorBlur: 'pink-login',
            // handleSuccess: () => {
            //   window.location.reload()
            // },
            close: () => {
              dispatch({
                type: 'set',
                payload: {
                  modalActive: null,
                },
              })
            },
          },
        },
      },
    })
  }

  const myRef = useRef(null)

  const executeScroll = () => myRef.current.scrollIntoView()

  return (
    <div className="f-participaSection-container">
      <div id="como-participar" className="f-topSection-container__ancla" />
      <h2 className="f-participaSection-container__titulo">
        ¿CÓMO PARTICIPO? <br /> <span onClick={() => executeScroll()} />
      </h2>{' '}
      <div className="f-participaSection-container__wrapper">
        <span
          ref={myRef}
          className="f-participaSection-container__ref-scroll"
        />
        <div className="f-participaSection-container__wrapper__section1">
          <span className="numeracion uno">01</span>
          <div className="f-participaSection-container__wrapper__section1__contentInfo1">
            <h2>INICIA SESIÓN</h2>
            <p>
              Para comenzar debes{' '}
              <span
                className="subrayado"
                onClick={() => {
                  modalLogin()
                }}
              >
                iniciar sesión
              </span>{' '}
              con tus datos de NosotrasOnline. Si aún no estás registrada,
              <span> ¡No tienes de qué preocuparte!</span>
            </p>
            <Button
              text="REGÍSTRATE AQUÍ"
              secondary
              size="registrate"
              onClick={() => {
                window.open(
                  siteUrl + '/registro/fecha-de-nacimiento/',
                  '_blank'
                )
              }}
            />
          </div>
          <img src={laptop} alt="computadora de nosotras" />
        </div>

        <div className="f-participaSection-container__wrapper__section1">
          {!mobile && <img src={paquete} alt="paquete de nosotras" />}
          <span className="numeracion dos">02</span>
          <div className="f-participaSection-container__wrapper__section1__contentInfo1">
            <h2>REDIME PUNTOS</h2>
            <p>
              Recuerda que para poder jugar, <span>debes redimir</span>{' '}
              <img
                className="puntosCover"
                src={puntos20}
                alt="puntos para redimir de nosotras"
              />
              de tus puntos acumulados. <br /> <br />
              Si aún no tienes <span>¡puedes estar tranquila!</span> Inscribe
              las claves personales de tus productos Nosotras.
            </p>
            <Button
              text="AQUÍ"
              secondary
              size="registrate"
              onClick={() => {
                window.open(siteUrl + '/mis-puntos/que-son/', '_blank')
              }}
            />
          </div>
          {mobile && <img src={paquete} alt="paquete de nosotras" />}
        </div>

        <div className="f-participaSection-container__wrapper__section1 seccion3">
          <span className="numeracion tres">03</span>
          <div className="f-participaSection-container__wrapper__section1__contentInfo1">
            <h2>JUEGA</h2>
            <p>
              <span>¿Estás lista para jugar?</span> <br />
              <br /> <span>¡Pon a prueba tus conocimientos!</span> <br /> Baja
              la palanca, responde la pregunta en el menor tiempo posible, y
              sigue con las siguientes preguntas. <br /> <br />
              <span>Tendrás 2 ayudas:</span> solo las podrás usar 1 vez. Redime{' '}
              <img
                className="puntosCover"
                src={puntos5}
                alt="puntos para redimir de nosotras"
              />
              para cada una de estas ayudas. ¡Tendrás 10 segundos adicionales!{' '}
              <br /> <br />
              <span>
                ¡Ganarás si respondes las preguntas correctamente! <br /> ¿Lista
                para jugar?
              </span>
            </p>
            <Button
              text="HAZ CLIC AQUÍ"
              size="registrate"
              onClick={() => {
                navigate('/juega')
              }}
            />
          </div>
          <img src={jackPotParticipar} alt="computadora de nosotras" />
        </div>
        <div className="f-participaSection-container__wrapper__section1">
          {!mobile && (
            <img src={premiosParticipa_DO} alt="premios de nosotras" />
          )}
          <span className="numeracion dos">04</span>
          <div className="f-participaSection-container__wrapper__section1__contentInfo1">
            <h2>GANA</h2>
            <p>
              <span>
              Del top 1 al 10, un kit de productos nosotras + una bolsa de agua + una mochila

              </span>{' '}
              <br /> <br /> Antes de jugar, conoce todos los{' '}
              <span
                className="subrayado"
                onClick={() => {
                  dispatch({
                    type: 'set',
                    payload: {
                      modalActive: {
                        type: 'terms',
                        props: {
                          close: () => {
                            dispatch({
                              type: 'set',
                              payload: {
                                modalActive: null,
                              },
                            })
                          },
                        },
                      },
                    },
                  })
                }}
              >
                términos y condiciones aquí{' '}
              </span>{' '}
              <br /> <br />
              <span>Ahora sí, ¡a jugar!</span>
            </p>
            <Button
              text="¡QUIERO JUGAR!"
              size="registrate"
              onClick={() => {
                navigate('/juega')
              }}
            />
          </div>
          {mobile && (
            <img src={premiosParticipa_DO} alt="premios de nosotras" />
          )}
        </div>
      </div>
    </div>
  )
}

export default ParticipaSection
